export default "__VITE_ASSET__DUt6me77__"